import PropTypes from 'prop-types';

import { legacyTheme, ThemeProvider as EmotionThemeProvider } from '@prose-ui/legacy';

/**
 * @deprecated: Please use palettes from @prose-ui/theme instead.
 */
export const { common: palette } = legacyTheme.palette;

/**
 * From Figma
 *
 * <- lighter     standard      darker ->
 * light2 light1 medium dark1 dark2
 * @deprecated: Please use @prose-ui/theme instead.
 */
export const { primary } = legacyTheme.palette;

/**
 * @deprecated: Please use palettes from @prose-ui/theme instead.
 */
export const { backgrounds } = legacyTheme.palette;

/**
 * @deprecated: Please use breakpoints from @prose-ui/theme instead.
 */
export const breakpoints = {
  xs: 360,
  sm: 768, // tablet width (portrait)
  md: 1024, // tablet width (landscape)
  lg: 1280, // desktop width
  xl: 1920,
};

const breakpointMedia = value => `@media (max-width: ${value - 0.05}px)`;

const breakpointMediaUp = value => `@media (min-width: ${value - 0.05}px)`;

export const breakpointMatches = value => {
  if (typeof value === 'string') {
    if (breakpoints[value]) {
      return breakpointMedia(breakpoints[value]);
    }
    throw new Error(
      `Expected value to be one of the values [${Object.keys(breakpoints).join(', ')}]`
    );
  } else if (typeof value === 'number') {
    return breakpointMedia(value);
  } else {
    throw new Error('Expected value to be a string or a number');
  }
};

const ipadProPortraitBreakpoints = `@media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2)  and (orientation: portrait)`;

const breakpointUp = value => {
  if (typeof value === 'string') {
    if (breakpoints[value]) {
      return breakpointMediaUp(breakpoints[value]);
    }
    throw new Error(
      `Expected value to be one of the values [${Object.keys(breakpoints).join(', ')}]`
    );
  } else if (typeof value === 'number') {
    return breakpointMediaUp(value);
  } else {
    throw new Error('Expected value to be a string or a number');
  }
};

const widths = {
  narrow: 327,
  half: 500,
  normal: 624,
  wide: 950,
  veryWide: 1200,
};

/**
 * @deprecated: Please use spacing from @prose-ui/theme instead.
 */
export const spacings = {
  s8: 8,
  s12: 12,
  s16: 16,
  s24: 24,
  s32: 32,
  s36: 36,
  s40: 40,
  s48: 48,
  s56: 56,
  s64: 64,
  s72: 72,
  s80: 80,
  s96: 96,
  s144: 144,
  s272: 272,
};

// typography constants
/**
 * @deprecated: Please use @prose-ui/theme instead.
 */
export const { simplonMono } = legacyTheme.typography;
/**
 * @deprecated: Please use @prose-ui/theme instead.
 */
export const { simplonNorm } = legacyTheme.typography;
/**
 * @deprecated: Please use @prose-ui/theme instead.
 */
export const { saol } = legacyTheme.typography;

/**
 * @deprecated: Please use @prose-ui/theme instead.
 */
export { typographyVariants } from '@prose-ui/legacy/legacyTheme';

// other constants
const bannerHeight = 40;
const navbarHeight = 55;
const buttonHeight = 53;
export const headerHeight = bannerHeight + navbarHeight;

export const fullHeight = () => typeof window !== 'undefined' && window.innerHeight - headerHeight;
const fullHeightWithFixedCTA = () =>
  typeof window !== 'undefined' && window.innerHeight - headerHeight - buttonHeight;

/**
 * @deprecated: Please use @prose-ui/theme instead.
 */
export const theme = {
  breakpoints: {
    values: breakpoints,
    match: breakpointMatches,
    ipadProPortrait: ipadProPortraitBreakpoints,
    up: breakpointUp,
  },
  utils: legacyTheme.utils,
  palette: legacyTheme.palette,
  props: {
    minimumBlockPadding: spacings.s24,
    verticalSpacingMob: spacings.s72,
    verticalSpacingDes: spacings.s144,
    buttonHeight,
    bannerHeight,
    navbarHeight,
    headerHeight,
    fullHeight: fullHeight(),
    fullHeightWithFixedCTA: fullHeightWithFixedCTA(),
    checkboxSize: { small: 16, medium: 28, large: 40 },
  },
  width: widths,
  spacing: spacings,
  typography: legacyTheme.typography,
  zIndex: legacyTheme.zIndex,
  shadows: legacyTheme.shadows,
};

const ThemeProvider = ({ children }) => (
  <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>
);

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeProvider;
